export default function handleFilters() {
  // const filtersContainer = document.createElement("div");

  // filtersContainer.classList.add("filters-container");
  // const filterValues = {};

  // Object.entries(filtersData).forEach(([filterKey, filter]) => {
  //   const filterElement = createFilterElement(
  //     filterKey,
  //     filter.type,
  //     filter,
  //     filterValues,
  //   );
  //   if (filterElement) {
  //     filtersContainer.appendChild(filterElement);
  //   }
  // });

  // element.insertAdjacentElement("beforebegin", filtersContainer);
  const existingFilterContainer = document.getElementById("helium-filters");
  if (existingFilterContainer) {
    console.log("Filters already exist, not creating again");
    return;
  }
  document.getElementById("helium-filters")?.remove?.();
  const element = document.createElement("div");
  document.body.appendChild(element);
  window.helium.ui.renderFilters(element);
}
